import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import CircleWrapper from "layouts/wrapper/CircleWrapper";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux"
import { useContext, useEffect, useState } from "react";
import Center from "layouts/wrapper/Center";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import P from "components/P";
import clsx from "classnames";
import style from "./Footer.module.css"
import Dummy from "components/Dummy";
import { requester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import CustomIcon from "components/icons/CustomIcon";
import Container from "layouts/container/Container";
import VerticalFlex from "layouts/flex/VerticalFlex";
import img1 from "resources/img/footer/1.png";
import img2 from "resources/img/footer/2.png";
import img3 from "resources/img/footer/3.png";
import img4 from "resources/img/footer/4.png";
import img5 from "resources/img/footer/5.png";
import { ReactComponent as Logo1 } from "resources/img/logo/logo.svg";
import { ReactComponent as Logo2 } from "resources/img/logo/01.svg";
import { ReactComponent as Logo3 } from "resources/img/logo/02.svg";
import { ReactComponent as Logo4 } from "resources/img/logo/03.svg";
import { ReactComponent as Logo5 } from "resources/img/logo/04.svg";
import { ReactComponent as Logo6 } from "resources/img/logo/05.svg";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import { useTranslation } from "react-i18next";
import NiceModal from "@ebay/nice-modal-react";
import Inline from "layouts/container/Inline";
import AccordionWrapper from "components/accordion/AccordionWrapper";
import AccordionText from "components/accordion/AccordionText";

function Footer() {
    const { isMobile } = useContext(BrowserDetectContext);
    const { t } = useTranslation();
    const desktopFooterList = [
        { title: t("termsOfUse"), url: "/termsOfUse", orderNo: "" },
        { title: t("privacyPolicy"), url: "/privacyPolicy", orderNo: "" },

    ];

    const Tab = ({ index, url, icon, text }) => {
        const [active, setActive] = useState(false);
        const color = active ? "var(--main-color)" : "var(--font-color-disabled)";

        return (
            <div >
                <NavLink to={url} style={({ isActive }) => { setActive(isActive); }} >
                    <Center>
                        <CustomIcon name={icon} color={color} width={20} />
                        <Dummy height={5} />
                        <P size={10} color={color} >{text}</P>
                    </Center>
                </NavLink>
            </div>
        );
    }

    const accordionStyle = {
        '--cui-accordion-bg': "white",
        '--cui-accordion-active-color': "var(--font-color)",
        '--cui-accordion-color': "var(--font-color)",
        '--cui-accordion-active-bg': "var(--user-bg-color)",
        '--cui-accordion-btn-focus-border-color': "none",
        '--cui-accordion-btn-focus-box-shadow': "none",
    }

    return (
        <Container backgroundColor={isMobile ? "#4D4F56" : "#eee"} minWidth={!isMobile && 1520}>
            {
                isMobile ?
                    // <div className={style.fixed}>
                    //     <HorizontalFlex gap={10}>
                    //         < FlexChild >
                    //             <Tab index={0} url={"productList/category/all"} icon={"menu"} text={"모든상품"} />
                    //         </FlexChild >
                    //         <FlexChild>
                    //             <Tab index={1} url={"wishList"} icon={"heart"} text={t("wishList")} />
                    //         </FlexChild>
                    //         <FlexChild>
                    //             <Tab index={2} url={"/"} icon={"home"} text={t("home")} />
                    //         </FlexChild>
                    //         <FlexChild>
                    //             <Tab index={3} url={"/mypage"} icon={"profile"} text={t("mypage")} />
                    //         </FlexChild>
                    //         <FlexChild>
                    //             <Tab index={4} url={"/shopping/cart"} icon={"cart"} text={t("cart")} />
                    //         </FlexChild>
                    //     </HorizontalFlex>
                    // </div>
                    <VerticalFlex>
                        <FlexChild backgroundColor={"#4D4F56"}>
                            <PaddingWrapper >
                                <Container >
                                    <VerticalFlex>
                                        <FlexChild>
                                            <Dummy height={"3rem"} />
                                            <P color={"#B8BCCA"} size={"0.7rem"}>법인명(상호) : 주식회사 푸푸 | 대표이사(성명) : 원태범</P>
                                            <P color={"#B8BCCA"} size={"0.7rem"}> 사업자등록번호 : [729-86-02229]</P>
                                            <P color={"#B8BCCA"} size={"0.7rem"}>개인정보보호책임자 : 이경문(puffuofficial@gmail.com)</P>
                                            <P color={"#B8BCCA"} size={"0.7rem"}>고객센터 : 070-4187-5511 | Fax : 042-489-8759</P>
                                            <P color={"#B8BCCA"} size={"0.7rem"}>주소 : (35372)대전광역시 서구 관저동 1115 3층</P>
                                            <P color={"#B8BCCA"} size={"0.7rem"}>Copyright 2021.puffu Corp. All rights reserved.</P>
                                            <Dummy height={"3rem"} />
                                        </FlexChild>
                                    </VerticalFlex>
                                </Container>
                            </PaddingWrapper>
                        </FlexChild>
                    </VerticalFlex>
                    :
                    <Container maxWidth={1520} >
                        <VerticalFlex>
                            <FlexChild height={60} >
                                <div className={style.desktopFooterWrap}>
                                    <Container maxWidth={1200}>
                                        <HorizontalFlex gap={20} justifyContent={"center"}>
                                            {
                                                desktopFooterList.map((item, index) =>
                                                    <FlexChild key={index} width={150}>
                                                        <Center>
                                                            <div className={style.footerColumn}>
                                                                <Link to={item.url}>
                                                                    {item.title}
                                                                </Link>
                                                            </div>
                                                        </Center>
                                                    </FlexChild>
                                                )
                                            }
                                        </HorizontalFlex>
                                    </Container>
                                </div>
                            </FlexChild>
                            <FlexChild >
                                <PaddingWrapper padding={20}>

                                    <HorizontalFlex>
                                        <FlexChild>
                                            <VerticalFlex padding={10}>
                                                <FlexChild>
                                                    <HorizontalFlex justifyContent={"flex-start"}>
                                                        <P>상호 : 보람정보기술 | </P>
                                                        <P>주소 : (34209)대전광역시 유성구 학하남로 10</P>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                                <FlexChild>
                                                    <HorizontalFlex justifyContent={"flex-start"}>
                                                        <P>{t("사업자등록번호 : ")} </P>
                                                        <P> 117-18-78441 | </P>
                                                        <P>{t("ceo")} : 이보람</P>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                                <FlexChild>
                                                    <HorizontalFlex justifyContent={"flex-start"}>
                                                        <P>{t("email")} :  </P>
                                                        <P>fjdgj123@naver.com </P>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                                {/* <FlexChild>
                                                    <HorizontalFlex justifyContent={"flex-start"}>
                                                        <P>{t("mailOrderNumber")} :  </P>
                                                        <P>2021-대전서구-0794 </P>
                                                    </HorizontalFlex>
                                                </FlexChild> */}
                                                <FlexChild >
                                                    <HorizontalFlex justifyContent={"flex-start"}>
                                                        <P>Copyright © 2020 Boram Information Technology Co., Ltd. All rights reserved.</P>
                                                    </HorizontalFlex>
                                                </FlexChild>
                                            </VerticalFlex>
                                        </FlexChild>
                                        {/* <FlexChild>
                                            <Logo4 fill={"#aaa"} width={200} />
                                        </FlexChild> */}
                                    </HorizontalFlex>
                                </PaddingWrapper>
                            </FlexChild>
                        </VerticalFlex>
                    </Container>
            }
        </Container>
    );
}

export default Footer;



